import { InputLabel, styled } from "@mui/material";
const InputLabelStyled = styled(InputLabel)(({ theme }) => ({
    fontSize: 14,
    color: "#586A84",
    transform: "none",
    WebkitTransform: "none",
    msTransform: "none",
    MozTransformOrigin: "none",
}));
export default InputLabelStyled;
